// User service
// - Encapsulates user account operations and profile-related helpers
// - Keep functions small and focused on a single responsibility
// - Uses the `supabase` client for auth and user management

import { supabase } from "../lib/supabase";

// Update the current authenticated user's password
// - Accepts the new password and returns `true` on success and `false` on failure
// - Errors are logged for debugging and not propagated to the caller
export async function updateUserPassword(
  newPassword: string,
): Promise<boolean> {
  try {
    const { error } = await supabase.auth.updateUser({
      password: newPassword,
    });

    if (error) {
      console.error("🔴 Error updating password:", error);
      return false;
    }

    return true;
  } catch (error) {
    console.error("🔴 Error in updateUserPassword:", error);
    return false;
  }
}
